import { Service, signal, computed } from '@angular/core';
import { MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH, TABLET_MIN_WIDTH } from '@theme/breakpoints';

@Service()
export class ViewportService {
  private readonly _width = signal<number | null>(
    globalThis.window === undefined ? null : globalThis.window.innerWidth
  );

  readonly isTabletOrBelow = computed(() => {
    const width = this._width();
    return width !== null && width <= TABLET_MAX_WIDTH;
  });

  readonly isDesktop = computed(() => {
    const width = this._width();
    return width !== null && width > TABLET_MAX_WIDTH;
  });

  readonly isMobileOrBelow = computed(() => {
    const width = this._width();
    return width !== null && width <= MOBILE_MAX_WIDTH;
  });

  readonly isTabletOnly = computed(() => {
    const width = this._width();
    return width !== null && width >= TABLET_MIN_WIDTH && width <= TABLET_MAX_WIDTH;
  });

  updateWidth(width: number): void {
    this._width.set(width);
  }
}
